import { useGlobalization } from '@Translations';
import { SensorConfigFormShape } from '@Types/configurations.types';
import TextField from '@mui/material/TextField';
import React, { useMemo } from 'react';
import { useConnectionPeek } from '../../hooks/useConnectionPeek';
import { CircularProgress, Typography } from '@mui/material';
import { getValue } from '@Selectors';
import { useSelector } from 'react-redux';
import {
	StyledContainer,
	StyledLegendContainer,
} from './ConnectionStringPeekField.styles';

export interface ConnectionStringPeekProps {
	formData: SensorConfigFormShape;
}

export const ConnectionStringPeekField = (props: ConnectionStringPeekProps) => {
	const { t } = useGlobalization();
	const {
		editSensorData: {
			peek: { queryComputing },
		},
	} = useSelector(getValue);

	const isComputing = useMemo(
		() => queryComputing === 'pending',
		[queryComputing],
	);

	const { peekQuery } = useConnectionPeek(
		props.formData as SensorConfigFormShape,
	);

	return (
		<StyledContainer>
			<TextField
				name={'connectionStringPeek'}
				value={peekQuery}
				color={'primary'}
				fullWidth
				margin={'normal'}
				label={t('Query String')}
				variant="outlined"
				disabled
				multiline
				inputProps={{ sx: { fontFamily: 'Monospace' } }}
			/>
			<StyledLegendContainer isComputing={isComputing}>
				<CircularProgress size={18} />
				<Typography>{t('Computing')}</Typography>
			</StyledLegendContainer>
		</StyledContainer>
	);
};
